import styled, { css } from 'styled-components'
import { pxToRem } from 'src/theme'

import FormLabel from '../FormLabel'

type InputStyleProps = {
  $isError?: boolean
  $isActive?: boolean
  $hasLabel?: boolean
  $hasFloatingLabel?: boolean
  $isDisabled?: boolean
  $hasErrorMessage?: boolean
  $size?: 'default' | 'small'
}

export const Container = styled.div<InputStyleProps>`
  display: flex;
  flex-flow: column;

  // disabled
  ${({ $isDisabled }) =>
    $isDisabled === true &&
    css`
      opacity: 0.8;
      &,
      & * {
        cursor: not-allowed;
      }
    `}
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.m375_body};
  color: ${({ theme }) => theme.colors.blueLight};
  margin-bottom: 1.2rem;
`

export const Wrapper = styled.div``

export const InputContainer = styled.div<InputStyleProps>`
  border: 1px solid rgba(0, 0, 0, 0.3);
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${pxToRem(16)};
  width: 100%;
  transition: border-color 0.3s ease-in-out;
  ${({ $isError, theme }) =>
    $isError === true &&
    css`
      border-color: ${theme.colors.error};
    `}
  ${({ $isActive }) =>
    $isActive === true &&
    css`
      border-color: ${({ theme }) => theme.colors.black};
    `}
`

export const Label = styled(FormLabel)``

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  position: relative;
`

export const inputStyle = css<InputStyleProps>`
  ${({ theme }) => theme.textStyles.m375_body};
  line-height: 1;
  width: 100%;
  border: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.7);
  background: transparent;
  min-height: ${pxToRem(164)};
  resize: none;
  &::placeholder {
    color: rgba(0, 0, 0, 0.7);
  }
  // disabled
  ${({ $isDisabled }) =>
    $isDisabled === true &&
    css`
      pointer-events: none;
    `}
  ${({ $isActive }) =>
    $isActive === true &&
    css`
      color: ${({ theme }) => theme.colors.black};
    `}
  ${({ $isError }) =>
    $isError === true &&
    css`
      color: ${({ theme }) => theme.colors.error};

      &::placeholder {
        color: ${({ theme }) => theme.colors.error};
      }
    `}
  // readonly
  &[readonly] {
    cursor: default;
  }
  &:focus {
    outline: none;
  }
  &[type='password'] {
    letter-spacing: 3px;
  }
`

export const Input = styled.textarea<InputStyleProps>`
  ${inputStyle}
`

export const HelpMessage = styled.p`
  ${({ theme }) => theme.textStyles.m375_bodySmall}
  color: ${({ theme }) => theme.colors.black};
  text-align: left;
`
export const ErrorMessage = styled.p`
  ${({ theme }) => theme.textStyles.m375_bodySmall}
  color: ${({ theme }) => theme.colors.error};
  margin-top: ${pxToRem(8)};
  text-align: left;
`
